export const DebtReportTypes = {
  SHOW_DEBT_REPORTS: "SHOW_DEBT_REPORTS",
  SHOW_DEBT_REPORT_DETAIL: "SHOW_DEBT_REPORT_DETAIL",
  DELETE_DEBT_REPORT: "DELETE_DEBT_REPORT",
};
